import { Collapsible_Panel_default } from "./chunk-3YRGCIXA.js";
import { Collapsible_default } from "./chunk-YRAVL6M6.js";
import { Collapsible_Header_default } from "./chunk-ZG67QBWN.js";
import { Collapsible_Button_default } from "./chunk-C3SP6PIJ.js";

// src/components/Collapsible/index.ts
var CollapsibleComponent = Collapsible_default;
CollapsibleComponent.Header = Collapsible_Header_default;
CollapsibleComponent.Header.displayName = "Collapsible.Header";
CollapsibleComponent.Panel = Collapsible_Panel_default;
CollapsibleComponent.Panel.displayName = "Collapsible.Panel";
CollapsibleComponent.Button = Collapsible_Button_default;
CollapsibleComponent.Button.displayName = "Collapsible.Button";
export { CollapsibleComponent };